import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import encrypt from '../api/encrypt';

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      setError('Missing reset token in URL.');
    }
  }, [token]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    // Basic validation
    if (!token) {
      setError('No token found. Check your link or request a new reset email.');
      return;
    }
    if (!newPassword || !confirmPassword) {
      setError('Please fill out both fields.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);

    try {
      // Encrypt the new password
      const encryptedPassword = encrypt(newPassword);

      // Send to backend
      const res = await fetch('https://register.vectorvault.io/reset_account_password', {
        method: 'POST',
        headers: {
          'Authorization': 'expected_authorization_code',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token,
          new_encrypted_password: encryptedPassword
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        // Show error if the request failed
        setError(data.message || 'Failed to reset password.');
      } else {
        setSuccess('Your password has been reset successfully!');
      }
    } catch (err) {
      console.error(err);
      setError('An unexpected error occurred. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      backgroundColor: '#080808', 
      minHeight: '100vh', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'flex-start',
      padding: '80px 20px',
      fontFamily: "'Inter', sans-serif",
      color: '#ffffff',
    }}>
      <div style={{ 
        maxWidth: '420px', 
        width: '100%',
        backgroundColor: '#0d0d0d',
        border: '1px solid #1a1a1a',
        borderRadius: '16px',
        padding: '36px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
      }}>
        <h2 style={{ marginBottom: '24px', fontWeight: '700', letterSpacing: '-0.02em', fontSize: '1.5rem' }}>Reset Password</h2>

        {error && <div style={{ 
          color: '#ff6b6b', marginBottom: '16px', padding: '10px 14px', 
          backgroundColor: 'rgba(255, 68, 68, 0.1)', border: '1px solid rgba(255, 68, 68, 0.2)',
          borderRadius: '8px', fontSize: '14px',
        }}>{error}</div>}
        {success && <div style={{ 
          color: '#00d67a', marginBottom: '16px', padding: '10px 14px', 
          backgroundColor: 'rgba(0, 214, 122, 0.1)', border: '1px solid rgba(0, 214, 122, 0.2)',
          borderRadius: '8px', fontSize: '14px',
        }}>{success}</div>}

        {!success && (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#999999' }}>New Password</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                disabled={loading}
                style={{
                  width: '100%', padding: '12px 14px', backgroundColor: '#111111',
                  border: '1px solid #222222', borderRadius: '8px', color: '#ffffff',
                  fontSize: '15px', fontFamily: "'Inter', sans-serif", outline: 'none', boxSizing: 'border-box',
                }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#999999' }}>Confirm Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                disabled={loading}
                style={{
                  width: '100%', padding: '12px 14px', backgroundColor: '#111111',
                  border: '1px solid #222222', borderRadius: '8px', color: '#ffffff',
                  fontSize: '15px', fontFamily: "'Inter', sans-serif", outline: 'none', boxSizing: 'border-box',
                }}
              />
            </div>
            
            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '12px', backgroundColor: '#00d67a', color: '#000000',
              border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer', fontFamily: "'Inter', sans-serif",
              opacity: loading ? 0.7 : 1,
            }}>
              {loading ? 'Submitting...' : 'Reset Password'}
            </button>
          </form>
        )}

        {success && (
          <button 
            onClick={() => navigate('/login')}
            style={{
              width: '100%', padding: '12px', backgroundColor: '#0d0d0d', color: '#ffffff',
              border: '1px solid #1a1a1a', borderRadius: '8px', fontSize: '15px', fontWeight: '500',
              cursor: 'pointer', fontFamily: "'Inter', sans-serif",
            }}
          >
            Back to Login
          </button>
        )}
      </div>
    </div>
  );
}

export default ResetPasswordPage;
